import { render, staticRenderFns } from "./BranchDRIReview.vue?vue&type=template&id=75d0ab98&"
import script from "./BranchDRIReview.vue?vue&type=script&lang=js&"
export * from "./BranchDRIReview.vue?vue&type=script&lang=js&"
import style0 from "./BranchDRIReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports